import { render, staticRenderFns } from "./service_tickets.vue?vue&type=template&id=cb3a2890&scoped=true&"
import script from "./service_tickets.vue?vue&type=script&lang=js&"
export * from "./service_tickets.vue?vue&type=script&lang=js&"
import style0 from "./service_tickets.vue?vue&type=style&index=0&id=cb3a2890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a2890",
  null
  
)

export default component.exports